<template>
  <div v-loading="globalLoading" class="table-pagination">
    <FormCustom
      v-if="!formDisable && formConfig.length != 0"
      ref="formCustom"
      v-model="queryCondition"
      :config="formConfig"
      :mount-and-query="false"
      :query-button-loading="loading"
      :reset.sync="resetForm"
      class="table-pagination-condition"
      @query="handleQuery"
      @other-click="$emit('other-click', queryCondition)"
      @add-click="handleAddClick"
    />

    <div class="table-pagination-content">
      <div v-if="headerRenderConfig" class="table-pagination-content-top">
        <template v-for="item in headerRenderConfigComputed">
          <el-button
            class="table-pagination-button"
            :key="'headerRender-' + item.key"
            v-if="item.auth(item)"
            v-bind="item.attrs"
            @click="item.click"
          >
            {{ item.text }}
          </el-button>
          <span
            v-if="item.aux"
            :key="'headerRenderAux-' + item.key"
            class="table-pagination-add-button-aux"
          >
            <img :src="item.auxIcon" />
            <span>{{ item.aux }}</span>
          </span>
        </template>
      </div>

      <div class="table-container">
        <el-table
          ref="table"
          border
          v-loading="loading"
          :data="tableData"
          :row-key="getRowKeys"
          :span-method="spanMethod"
          :summary-method="summaryMethod"
          :show-summary="showSummary"
          :sum-text="sumText"
          :default-sort="defaultSort"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <slot name="before" />
          <el-table-column
            v-if="selection"
            align="left"
            type="selection"
            :reserve-selection="true"
            :selectable="selectable"
            width="40"
          />
          <el-table-column
            v-if="hasIndex"
            label="序号"
            prop="tableIndex"
            align="left"
            width="70"
          />

          <template v-for="(column, index) in columns">
            <ElTableColumnCustom
              :key="column.prop + index"
              :column="column"
              :align="align"
              :sort-prop.sync="sortPropCustom"
              :sort-custom="sortCustom"
              @sortPropChange="handleSortPropChange"
            />
          </template>

          <slot />

          <el-table-column
            v-if="tabelRenderConfig"
            :label="tabelRenderConfig.label || tabelRenderConfigArr.label"
            :width="tabelRenderConfig.width || tabelRenderConfigArr.width"
          >
            <template slot-scope="scope">
              <template v-for="item in tabelRenderConfigComputed">
                <label
                  class="tabel-render"
                  v-if="item.auth(scope.row)"
                  :key="'tabelRender-' + item.key"
                  v-bind="item.attrs"
                  @click="item.click(scope.row)"
                >
                  {{ item.text }}
                </label>
              </template>
            </template>
          </el-table-column>

          <slot name="after" />

          <template slot="empty">
            <NoData
              :show-pic="noDataShowPic"
              :style="{
                top: `${noDataTop}px`,
              }"
              title="暂无数据"
            />
          </template>
        </el-table>
      </div>
    </div>
    <div class="table-pagination-footer">
      <el-pagination
        v-if="paginationEnable"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        :page-sizes="[pagination.count]"
        :page-size="pagination.count"
        :current-page="pagination.page"
        @size-change="handleCountChange"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
/**
 * 新增导入
 * importEnable 展示条件
 * @import-data 点击导入的回调
 */
import Vue from "vue";
import ElTableColumnCustom from "../ElementTableCustom/ElTableColumnCustom/index";
import NoData from "@/components/GlobalComponents/NoData";
import gthimg from "$img/gth.png";

export default {
  name: "TablePagination",

  components: {
    ElTableColumnCustom,
    NoData,
  },

  props: {
    globalLoading: {
      type: Boolean,
      default: false,
    },

    description: {
      type: String,
      default: "",
    },

    columns: {
      type: Array,
      default: null,
    },

    formConfig: {
      type: Array,
      default: () => [],
    },
    formDisable: {
      type: Boolean,
      default: false,
    },
    //排序-默认的排序列的 prop 和顺序。它的prop属性指定默认的排序的列，order指定默认排序的顺序
    defaultSort: {
      type: Object,
      default: () => ({}),
    },
    //当表格的排序条件发生变化的时候会触发该事件	{ column, prop, order }
    sortChange: {
      type: Function,
      default: null,
    },
    //合计-是否在表尾显示合计行
    showSummary: {
      type: Boolean,
      default: false,
    },
    //合计-合计行第一列的文本
    sumText: {
      type: String,
      default: "合计",
    },
    //合计-自定义的合计计算方法
    summaryMethod: {
      type: Function,
      default: null,
    },
    //合计-合并行或列的计算方法
    spanMethod: {
      type: Function,
      default: null,
    },
    paginationEnable: {
      type: Boolean,
      default: true,
    },
    totalEnable: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: "",
    },

    questMethod: {
      type: String,
      default: "body",
    },

    urlFormatter: {
      type: Function,
      default: null,
    },

    exportParamFormatter: {
      type: Function,
      default: null,
    },

    paramsFormatter: {
      type: Function,
      default: null,
    },

    resultFormatter: {
      type: Function,
      default: null,
    },

    dataFormatter: {
      type: Function,
      default: null,
    },

    defaultSortProp: {
      type: String,
      default: "",
    },

    paramValidator: {
      type: Function,
      default: null,
    },

    align: {
      type: String,
      default: "left",
    },

    height: {
      type: [String, Number],
      default: null,
    },

    tableInnerAutoHeight: {
      type: Boolean,
      default: false,
    },
    hasIndex: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Boolean,
      default: false,
    },
    //仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    selectable: {
      type: Function,
      default: null,
    },
    noDataShowPic: {
      type: Boolean,
      default: true,
    },
    selectionId: {
      type: Array,
      default: () => [],
    },
    sortPropCustom: {
      default: "",
      type: String,
    },
    sortCustom: {
      default: false,
      type: Boolean,
    },
    rowKey: {
      type: String,
      default: "id",
    },
    reset: {
      default: false,
      type: Boolean,
    },
    tabHeight: {
      type: Number,
      default: 90,
    },
    httpType: {
      type: String,
      default: "post",
    },
    headerRenderConfig: {
      type: [Boolean, Object],
      default: false,
    },

    tabelRenderConfig: {
      type: [Boolean, Object],
      default: false,
    },
  },

  data() {
    return {
      gthimg,

      loading: false,

      exportLoading: false,

      queryCondition: {},

      tableHeight: "auto",

      tableKey: Math.random().toString(36).slice(2),

      tableData: [],

      currentExportParams: null,

      currentColumns: [],

      params: {},

      sortProp: "",

      pagination: {
        total: 0,
        page: 1,
        count: 20,
      },

      resetForm: false,

      noDataTop: 0,
      selectVal: [],
      headerRenderConfigArr: {
        create: {
          text: "添加",
          type: "primary",
          plain: true,
          aux: false,
          auxIcon: false,
          export: false,
        },
        default: {
          text: "添加",
          type: "primary",
          plain: true,
          aux: false,
          auxIcon: false,
          export: false,
          // auth: () => true || false,
        },
      },
      tabelRenderConfigArr: {
        label: "操作",
        width: 160,
        edit: {
          text: "编辑",
        },
        delete: {
          style: "color:#E74626",
          text: "删除",
        },
        default: {
          text: "编辑",
          // auth: () => true || false,
        },
      },
    };
  },
  computed: {
    // 统一设置表格上方 工具按钮
    headerRenderConfigComputed: function () {
      let configArr = [];
      Object.keys(this.headerRenderConfig).forEach((key) => {
        let newHeaderConfig = {};
        if (typeof this.headerRenderConfig[key] === "object") {
          newHeaderConfig = this.headerRenderConfig[key];
        } else {
          newHeaderConfig = {
            click: this.headerRenderConfig[key],
          };
        }
        let config = {
          key: key,
          ...(this.headerRenderConfigArr[key] ||
            this.headerRenderConfigArr.default),
          ...newHeaderConfig,
        };

        if (config.export) {
          config.click = this.dataExport(config.export);
        }

        if (!config.auth) {
          config.auth = () => true;
        }

        const { click, auth, text, ...rest } = config;

        config.attrs = rest;

        configArr.push(config);
      });
      return configArr;
    },
    tabelRenderConfigComputed: function () {
      let configArr = [];
      Object.keys(this.tabelRenderConfig).forEach((key) => {
        if (
          typeof this.tabelRenderConfig[key] !== "string" ||
          typeof this.tabelRenderConfig[key] !== "number"
        ) {
          let newTabelConfig = {};
          if (typeof this.tabelRenderConfig[key] === "object") {
            newTabelConfig = this.tabelRenderConfig[key];
          } else {
            newTabelConfig = {
              click: this.tabelRenderConfig[key],
            };
          }
          let config = {
            key: key,
            ...(this.tabelRenderConfigArr[key] ||
              this.tabelRenderConfigArr.default),
            ...newTabelConfig,
          };

          if (config.export) {
            config.click = this.dataExport(config.export);
          }

          if (!config.auth) {
            config.auth = () => true;
          }

          const { click, auth, text, ...rest } = config;

          config.attrs = rest;

          configArr.push(config);
        }
      });
      return configArr;
    },
  },

  watch: {
    height: {
      immediate: true,
      handler(val) {
        this.tableHeight = val;
      },
    },

    formConfig: {
      immediate: true,
      async handler(val) {
        if (!val || (val && !val.length)) return;

        await this.$nextTick();

        this.setTableHeight();
      },
    },

    defaultSortProp: {
      immediate: true,
      handler(val) {
        this.sortProp = val;
      },
    },

    columns: {
      immediate: true,
      async handler(val) {
        this.currentColumns = [...val];
      },
    },

    queryCondition: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit("params-change", newVal, oldVal);
      },
    },

    reset(val) {
      if (!val) return;

      this.resetForm = val;
      this.tableData = [];
      this.queryCondition = {};
      this.pagination = {
        total: 0,
        page: 1,
        count: 20,
      };
    },

    resetForm(val) {
      if (val) return;

      this.$emit("update:reset", false);
    },
  },

  methods: {
    getRowKeys(row) {
      if (this.rowKey) return row[this.rowKey];
    },
    handleSelectionChange(val) {
      //解决 tabel 选择全选后 字段太多超过屏幕大小 表头栏样式错位
      this.$refs.table.$refs.bodyWrapper.scrollLeft =
        this.$refs.table.$refs.bodyWrapper.scrollLeft + 1;
      this.$refs.table.$refs.bodyWrapper.scrollLeft =
        this.$refs.table.$refs.bodyWrapper.scrollLeft - 1;

      this.selectVal = val.map((item) => item.id);
      this.$emit("update:selectionId", this.selectVal);
    },
    setTableHeight() {
      // const el = this.$el;
      // const topEl = el.querySelector(".table-pagination-condition"),
      //   footEl = el.querySelector(".table-pagination-footer");

      let heightOffset = 10;

      if (this.paginationEnable) {
        heightOffset += 32;
      }

      if (this.headerRenderConfig) {
        heightOffset += 47;
      }

      this.tableHeight = `calc(100% - ${heightOffset + 5}px)`;
    },

    handleAddClick() {
      this.$listeners["add-click"] && this.$listeners["add-click"]();
    },

    handleSortPropChange(prop) {
      this.$emit("update:sortPropCustom", prop);
      this.$emit("sortPropChange", prop);

      this.$refs.table.sort(prop, "descending");
    },
    handleSortChange({ column, prop, order }) {
      if (this.sortChange && typeof this.sortChange === "function") {
        this.sortChange({ column, prop, order });
      } else {
        let orderType = null;
        let orderField = prop;

        if (order === "ascending") {
          orderType = "asc";
        } else if (order === "descending") {
          orderType = "desc";
        } else {
          orderField = null;
        }
        this.queryCondition = { ...this.queryCondition, orderType, orderField };
        this.queryData();
      }
    },
    handleCountChange(val) {
      this.pagination.count = val;

      // this.$emit("count-change", this.pagination);
      this.queryData();
    },

    handlePageChange(val) {
      this.pagination.page = val;

      // this.$emit("page-change", this.pagination);
      this.queryData();
    },

    handleTableSort(col) {
      this.tableData = this.tableData.sort(
        (prev, next) => next[col.prop] - prev[col.prop]
      );
      this.sortProp = col.prop;

      this.$emit("sort-change", col);
    },

    setQueryCondition({ key, val }) {
      this.queryCondition[key] = val;
    },
    /**
     *
     * @param model
     * @param config
     * @param loadTpye //加载类型 添加数据：成功后，默认跳转至第1页；
     *   编辑数据：成功后，默认停留在当前页；
     *   删除数据：成功后，若当前页已无数据，则到当前页-1，否则默认停留在当前页；
     */
    handleQuery(model, config, loadTpye = "default") {
      // console.log('调用调用', this.paginationEnable)
      if (this.paginationEnable) {
        if (loadTpye === "default") {
          this.pagination = {
            total: 0,
            page: 1,
            count: 10,
          };
        }
      }

      this.sortProp = this.defaultSortProp;

      this.queryData();
    },

    async queryData() {
      if (this.paramValidator && typeof this.paramValidator === "function") {
        let isValid = true;

        try {
          await this.paramValidator(this.queryCondition);
        } catch (e) {
          isValid = false;

          if (e.type === "PARAM_ERROR") {
            this.$fail(e.message);
          }
        }

        if (!isValid) return;
      }

      this.loading = true;

      let params = null;

      if (this.paramsFormatter) {
        params = this.paramsFormatter(this.queryCondition, this.pagination);
      } else {
        params = { ...this.queryCondition };
      }
      if (!this.paginationEnable) {
        params.page_flag = 0;
      }
      if (!this.totalEnable) {
        params.page_flag = 0;
      }

      params = {
        ...params,
        per_page: params.pageInfo.count,
        current_page: params.pageInfo.page,
      };
      this.params = params;

      let url = this.url;

      if (this.urlFormatter) {
        url = this.urlFormatter(url);
      }

      if (this.questMethod === "single") {
        let key = Object.keys(params)[0];

        url = `${this.url}?${key}=${encodeURI(params[key])}`;
        params = {};
      }

      try {
        let res;
        if (this.httpType === "post") {
          res = await this.$axios.post(url, { ...params, pageInfo: undefined });
        } else {
          res = await this.$axios.get(url, {
            params: {
              ...params,
              pageInfo: undefined,
            },
          });
        }
        if (this.resultFormatter) {
          res = this.resultFormatter(res);
        }

        this.$emit("tableData", res);

        let list, paging;
        if (res.data.items) {
          list = res.data.items;
          paging = res.data.paging;
        } else {
          list = res.data.result.items;
          paging = res.data.result.paging;
        }

        if (this.paginationEnable) {
          this.pagination.total = paging.total;
          this.$emit("total", paging.total);
        }
        res = list;

        if (Array.isArray(res)) {
          this.tableData = res.map((item, index) => {
            item.rank = index + 1;
            item.tableIndex =
              index + 1 + (this.pagination.page - 1) * this.pagination.count;

            return item;
          });
        }

        if (this.dataFormatter) {
          this.tableData = await this.dataFormatter(this.tableData, res);
        }
      } catch (e) {
        console.error(e);

        // this.$fail(e && e.reason ? e.reason : "查询失败");
      } finally {
        this.loading = false;

        this.$nextTick(() => {
          const $header = this.$el.querySelector(".el-table__header-wrapper");

          if ($header) {
            this.noDataTop = $header.clientHeight;
          }

          this.setTableHeight();
        });
      }
    },

    async dataExport(exportUrl) {
      this.exportLoading = true;

      try {
        // if (this.pagination.total > 200) {
        //   await this.$confirm("系统限制单次最多只能导出200条数据", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   });
        // }

        let exportParam = this.params;

        if (this.exportParamFormatter) {
          exportParam = this.exportParamFormatter(this.params);
        }
        await this.$axios.download(exportUrl, exportParam);
      } catch (err) {
        console.error(err);
        err.reason && this.$fail(err.reason);
      }

      this.exportLoading = false;
    },

    dataImport() {
      this.$emit("import-data");
    },
    importTemporary() {
      this.$emit("import-func");
    },
    quickApprovalImport() {
      this.$emit("quick-approval-data");
    },
    multipleDelFunc() {
      this.$emit("multiple-option");
    },

    compile(component, column, slotScope) {
      let template = Vue.compile(component.template);

      const data = {
        data() {
          return Object.assign({}, component.data, {
            column,
            scope: slotScope,
          });
        },
      };

      return Object.assign({}, template, data, component);
    },
  },
};
</script>
